<template>
  <div class="payments-view">
    <!-- HEADER -->
    <div class="page-header">
      <div class="header-left">
        <router-link to="/addpayment">
          <button class="btn btn-primary">
            + Dodaj płatność
          </button>
        </router-link>
        
        <div class="tabs">
          <router-link to="/payments-costs" class="tab">Koszty</router-link>
          <router-link to="/payments-due" class="tab tab-active">Należności</router-link>
          <router-link to="/payments-archive" class="tab">Zapłacone</router-link>
        </div>
      </div>

      <input
        v-model="search"
        class="search-input"
        type="search"
        placeholder="Wyszukaj kontrahenta..."
      />
    </div>

    <!-- SUMMARY -->
    <div class="summary">
      <div class="summary-item">
        <span class="summary-label">Całkowita kwota należności</span>
        <span class="summary-value">{{ allPaymentsValue }} PLN</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Liczba płatności</span>
        <span class="summary-value">{{ filteredPayments.length }}</span>
      </div>
    </div>

    <!-- TABLE -->
    <div class="table-container">
      <table class="payments-table">
        <thead>
          <tr>
            <th>Kontrahent</th>
            <th>Numer faktury</th>
            <th>Data płatności</th>
            <th>Kwota</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="payment in filteredPayments"
            :key="payment.id"
            class="payment-row"
            :class="{ 'row-overdue': payment.date <= formatDate }"
            @click="openPaymentModal(payment)"
          >
            <td>
              <div class="contractor-cell">
                <span class="icon">
                  {{ payment.contractor && payment.contractor.type == 'company' ? '🏢' : '👤' }}
                </span>
                <div class="contractor-info">
                  <span class="name">{{ payment.contractor && payment.contractor.label ? payment.contractor.label : 'Brak danych' }}</span>
                  <span class="type">{{ payment.type }}</span>
                </div>
              </div>
            </td>
            <td>{{ payment.invoiceNumber }}</td>
            <td>
              <span class="date-badge" :class="{ 'date-overdue': payment.date <= formatDate }">
                {{ payment.date }}
              </span>
            </td>
            <td>
              <span class="price">{{ payment.price }} PLN</span></td>
            <td>
              <span v-if="payment.lastEmailSent" class="badge-email" :title="formatEmailDate(payment.lastEmailSent)">
                ✉️ {{ formatEmailDate(payment.lastEmailSent) }}
              </span>
              <span v-if="payment.date <= formatDate" class="badge-overdue">Przeterminowane</span>
            </td>
            <td>
              <button class="btn-details" @click.stop="openPaymentModal(payment)">
                Szczegóły
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <payment-modal @closeModal="closeModal()" :payment="payment"></payment-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PaymentModal from "../components/PaymentModal";

export default {
  data() {
    return {
      //   installation: {
      //     brand: "",
      //     model: "",
      //     plate: "",
      //     vin: "",
      //     year: "",
      //     imageUrl: "",
      //   },
      //   openForm: false,
      search: "",
      payment: "",
      costsChecked: false,
      paymentsChecked: false,
      phoneSearch: "",
      today: new Date("yyyy-mm-dd"),
    };
  },
  components: {
    "payment-modal": PaymentModal,
  },

  computed: {
    ...mapState(["userProfile", "payments"]),
    formatDate() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    sortedPayments() {
      function compare(a, b) {
        return new Date(a.date) - new Date(b.date);
      }
      let arr = this.duePayments;

      return arr.sort(compare);
    },

    duePayments() {
      return this.payments.filter((i) => i.type === "Nalezności");
    },

    filteredPayments() {
      return this.sortedPayments.filter((item) => {
        // Sprawdź czy contractor istnieje
        if (!item.contractor) return false;

        const label = item.contractor.label || '';
        const phoneNumber = item.contractor.phoneNumber || '';
        const email = item.contractor.email || '';
        const nip = item.contractor.nip || '';
        const invoiceNumber = item.invoiceNumber || '';
        const searchUpper = this.search.toUpperCase();

        if (label.toUpperCase().includes(searchUpper)) {
          return item;
        } else if (phoneNumber.toUpperCase().includes(searchUpper)) {
          return item;
        } else if (invoiceNumber.toUpperCase().includes(searchUpper)) {
          return item;
        } else if (nip.toUpperCase().includes(searchUpper)) {
          return item;
        } else if (email.toUpperCase().includes(searchUpper)) {
          return item;
        }
      });
    },
    allPaymentsValue() {
      let allDue = 0;
      this.filteredPayments.forEach((element) => {
        let string = element.price.replace(",", ".");
        let num = parseFloat(string);
        allDue += num;
      });
      return allDue.toFixed(2);
    },
  },
  methods: {
    formatEmailDate(timestamp) {
      if (!timestamp) return '';
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);
      
      if (diffMins < 1) return 'Przed chwilą';
      if (diffMins < 60) return `${diffMins} min temu`;
      if (diffHours < 24) return `${diffHours}h temu`;
      if (diffDays < 7) return `${diffDays} dni temu`;
      
      return date.toLocaleDateString('pl-PL', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric'
      });
    },

    openPaymentModal(event) {
      // console.log(this.formatDate);
      this.$modal.show("payment-modal");
      this.payment = event;
      // Prevent navigating to narrower view (default vue-cal behavior).
      // e.stopPropagation();
    },
    closeModal() {
      this.$modal.hide("payment-modal");
    },
  },
  mounted() {
    const limits = this.$store.state.userProfile.limits;
    const limit = (limits && limits.payments) || 1000;
    this.$store.dispatch("getPayments", { limit });
  },
  beforeDestroy() {
    this.$store.commit("unsubscribeListener", "payments");
  },
};
</script>
<style scoped>
.payments-view {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 24px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.tabs {
  display: flex;
  gap: 4px;
  background: white;
  padding: 4px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.tab {
  padding: 10px 20px;
  border-radius: 6px;
  color: #6c757d;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.tab:hover {
  background: #f8f9fa;
  color: #495057;
}

.tab-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.search-input {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  min-width: 300px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* SUMMARY */
.summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.summary-item {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  overflow: hidden;
}

.summary-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.summary-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 12px;
}

.summary-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-left: 12px;
}

/* TABLE */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

.payments-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.payments-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.payments-table th {
  padding: 18px 20px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  z-index: 10;
}

.payments-table tbody tr {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.payments-table tbody tr::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
}

.payments-table tbody tr:hover {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  transform: scale(1.01);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  z-index: 1;
}

.payments-table td {
  padding: 20px;
  font-size: 14px;
  color: #2c3e50;
  vertical-align: middle;
}

.contractor-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon {
  font-size: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.payments-table tbody tr:hover .icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scale(1.1);
}

.contractor-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contractor-info .name {
  font-weight: 600;
  color: #2c3e50;
  font-size: 15px;
}

.contractor-info .type {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
}

.date-badge {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
}

.date-badge.date-overdue {
  color: #dc3545;
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
}

.price {
  font-weight: 600;
  color: #28a745;
  font-size: 14px;
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
}

.row-overdue {
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.05) 0%, rgba(220, 53, 69, 0.02) 100%);
  border-left: 4px solid #dc3545;
}

.row-overdue:hover {
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, rgba(220, 53, 69, 0.05) 100%);
}

.badge-email {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border-left: 3px solid #2196f3;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);
}

.badge-overdue {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  margin-left: 8px;
  border-left: 3px solid #dc3545;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.2);
}

.btn-details {
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-details:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-details:active {
  transform: translateY(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .payments-view {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .header-left {
    flex-direction: column;
    width: 100%;
  }

  .tabs {
    width: 100%;
  }

  .search-input {
    min-width: 100%;
  }

  .table-container {
    overflow-x: auto;
    border-radius: 8px;
  }

  .payments-table {
    min-width: 900px;
  }

  .payments-table th,
  .payments-table td {
    padding: 12px;
    font-size: 13px;
  }
}
</style>
